// extracted by mini-css-extract-plugin
module.exports = {"titlePrice":"styles_titlePrice__G1qr3","brandSize":"styles_brandSize__IEI_C","brand":"styles_brand__8RReH"};